/**
 * @fileoverview GET handler for the "" endpoint
 */
import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSqlSegmentCohortAccountUsage } from "./constants";
import type { SqlSegmentCohortAccountUsageResults } from "./types";

export const getEngagementApiSqlSegmentCohortsAccountUsage = reactQueryFetcherAdapter(
  engagementSqlSegmentCohortAccountUsage,
  async (): Promise<SqlSegmentCohortAccountUsageResults> => {
    return await fetch("/engagement/api/segment_cohorts/current_billing_cycle", "GET");
  }
);
